module.exports = __webpack_public_path__ + "img/tu06.2ec4551b.jpg";